module.exports = __webpack_public_path__ + "img/payinsight_Illustration.cb3700c2.svg";